import { API } from 'api';
import { LOCAL_STORAGE_KEY } from 'state/localStorage';
import { isVirtualTransaction } from 'features/payments/utils/detectIapCollision';

const skipSyncExecution = (storageKey: string): boolean => {
  const lastExecution = localStorage.getItem(storageKey);
  if (!lastExecution) return false;

  const lastDate = new Date(lastExecution);
  const now = new Date();

  const startOfLastDate = new Date(lastDate).setHours(0, 0, 0, 0);
  const startOfToday = new Date(now).setHours(0, 0, 0, 0);

  return startOfLastDate === startOfToday;
};

export const syncAppPurchase = async (
  originalTransactionId: string,
): Promise<void> => {
  if (skipSyncExecution(LOCAL_STORAGE_KEY.SYNC_APP_PURCHASE)) {
    return;
  }

  await API.post('/recurly_integration/add_original_transaction_id/', {
    originalTransactionId,
  });

  localStorage.setItem(
    LOCAL_STORAGE_KEY.SYNC_APP_PURCHASE,
    new Date().toISOString(),
  );
};

export const getLatestOriginalTransactionId = (
  transactions: CdvPurchase.Transaction[],
): string | null => {
  const userTransactions = transactions
    .filter(
      (tx) =>
        !isVirtualTransaction(tx) &&
        tx.state === CdvPurchase.TransactionState.APPROVED &&
        Boolean(tx.purchaseDate),
    )
    // Sort by date in ascending order - first transaction is the most recent
    .sort(
      (a, b) =>
        new Date(b.purchaseDate!).getTime() -
        new Date(a.purchaseDate!).getTime(),
    );

  if (!userTransactions.length) {
    return null;
  }

  // @ts-expect-error - originalTransactionId is not defined on the type
  return userTransactions[0].originalTransactionId;
};
